/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react"
import useTranslationHook, {
  englishLanguage,
} from "../../../hooks/use-translation.hook"
import styled from "styled-components"
import { InvinsibleBackdrop } from "../language-picker/language-picker.component"

const DropdownButton = styled.div`
  border: none;
  cursor: pointer;
  position: relative;
  padding: 0 5px;
  span {
    display: inline-block;
    font-size: 14px;
  }
  z-index: 2;
`

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`
const DropdownContent = styled.div`
  position: absolute;
  right: 0px;
  background-color: #f1f1f1;
  min-width: fit-content;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 2;
  transition: 0.3s ease-in-out;
`

const DropdownArrow = styled.span<{ active: boolean }>`
  position: absolute;
  top: 10px;
  right: -5px;
  transform: scale(0.7);
  &::before,
  &::after {
    position: relative;
    content: "";
    display: block;
    width: 10px;
    height: 1px;
    background: black;
    transition: 0.3s ease-in-out;
  }

  &::before {
    transform: ${({ active }) => (active ? "rotate(-45deg)" : "rotate(45deg)")};
  }

  &::after {
    left: 6px;
    top: -1px;
    transform: ;
    transform: ${({ active }) => (active ? "rotate(45deg)" : "rotate(-45deg)")};
  }
`

const DropdownItem = styled.div`
  padding: 4px 20px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    text-decoration: underline;
  }
`

const SimpleLanguagePicker = () => {
  const [active, setActive] = useState(false)
  const { language, translationOptions, changeLanguageManually } =
    useTranslationHook()
  const [currentLang, setCurrentLang] = useState(translationOptions[0])

  const setLanguage = (value: string) => {
    changeLanguageManually(value)
  }

  useEffect(() => {
    setActive(false)
    setCurrentLang(
      translationOptions.find(({ value }) => {
        return value === language
      }) || englishLanguage
    )
  }, [language, translationOptions])
  return (
    <DropdownContainer>
      <DropdownButton onClick={() => setActive((prev) => !prev)}>
        {currentLang.value}
        {"  "}
        <DropdownArrow active={active} />
      </DropdownButton>
      {active && (
        <>
          <DropdownContent>
            {translationOptions.map(({ value }, i) => {
              return (
                <DropdownItem key={i} onClick={() => setLanguage(value)}>
                  {value}
                </DropdownItem>
              )
            })}
          </DropdownContent>
          <InvinsibleBackdrop onClick={() => setActive(false)} />
        </>
      )}
    </DropdownContainer>
  )
}

export default SimpleLanguagePicker
